import { MDBRow} from "mdbreact";
import React from "react";
import IconCheck from "../../../../new_images/Landing/Icons/Icon_visto.png";
import "./Recomendaciones.css"


class Disfruta extends React.Component {
  render() {
    return (
      <section className="text-left my-5">
        <div style={{display:"flex", justifyContent:"center"}}>
          <div className=" col-lg-7 view-recomendacionc" style={{display:"grid"}}>
            <p
              className="ch_titulo " style={{margin:"5px"}}
            >
              Recomendaciones para conductores
            </p>
          </div>
        </div>

      <div style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "10px"
                }}>
        <div>
          <MDBRow>
            <MDBRow center style={{width:"100%"}}>
              <div className="col-lg-1" >
                <div className="img_num">
                <img src={IconCheck} height="30px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              </div>
              <div className="col-lg-6" >
                <p className="ch_texto">Revisa siempre los datos proporcionamos sobre el/los pasajeros y verifica la identidad del cada uno de los pasajeros.</p>
              </div>
            </MDBRow>
            <MDBRow center style={{width:"100%"}}>
              <div className="col-lg-1" >
                <div className="img_num">
                <img src={IconCheck} height="30px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              </div>
              <div className="col-lg-6" >
                <p className="ch_texto">¡No te distraigas mientras estás al volante! Mantén siempre la vista en el camino y evita el uso del teléfono celular mientras conduces.</p>
              </div>
            </MDBRow>
            <MDBRow center style={{width:"100%"}}>
              <div className="col-lg-1" >
                <div className="img_num">
                <img src={IconCheck} height="30px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              </div>
              <div className="col-lg-6" >
                <p className="ch_texto">Realiza un mantenimiento periódico al vehículo y procura mantenerlo limpio durante cada viaje.</p>
              </div>
            </MDBRow>
            <MDBRow center style={{width:"100%"}}>
              <div className="col-lg-1" >
                <div className="img_num">
                <img src={IconCheck} height="30px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              </div>
              <div className="col-lg-6" >
                <p className="ch_texto">Evita el consumo de bebidas alcohólicas y sustancias psicotrópicas mientras conduces. La seguridad de tus pasajeros y de tu propia vida depende de ti.</p>
              </div>
            </MDBRow>
          </MDBRow>   
        </div>
      </div>
    </section>
    );
  }
}

export default Disfruta;
